<template>
    <div class="voucher-text">
        <div class="mb-3 pb-1">
            <textarea v-model="current" @keyup="change($event.target.value)" :placeholder="lang.placeholder" class="fs-0875 mb-0 p-3" rows="16" :maxlength="maxLength"></textarea>
            <div class="d-flex justify-content-between">
                <span class="fs-075 opacity-40">{{ valueLength }} / {{ maxLength }} {{ lang.words }}</span>
                <span class="fs-075 opacity-40 cursor-pointer" v-if="valueLength > 0" @click="clear()"><u>{{ lang.clear }}</u></span>
            </div>
        </div>

        <div>
            <button class="btn-primary black d-block w-100" @click="save()">{{ lang.button }}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
        },
        lang: {
            type: Object,
        },
        maxLength: {
            type: Number,
            default: 500,
        },
    },

    data() {
        return {
            current: this.modelValue,
        }
    },

    computed: {
        valueLength: function () {
            return this.current.length;
        },
    },

    methods: {
        change(value) {
            this.$emit('update:modelValue', value);
            this.$emit('change');
        },
        save() {
            this.$emit('save');
        },
        clear() {
            this.change('');
        },
    }
}
</script>
